var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
import axios from 'axios'
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

export default {
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
        //将时间对象格式化为固定格式化字符串
        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        //将时间字符串,转化为时间对象
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        },
        //将时间字符串或者时间对象 格式化为 yyyy-MM-dd
        formatSimple(tObj){
            if(tObj==null||tObj==""){
                return "";
            }else{
                if (typeof(tObj) == 'string'){
                    tObj = tObj.replace(/\-/g, "/");
                }
                var tim =  new Date(tObj);
                var year = tim.getFullYear(); //年
                var month = tim.getMonth() + 1; //月
                month = month < 10 ? '0' + month : month;
                var day = tim.getDate();//日
                day = day < 10 ? '0' + day : day;
                return year + '-' + month + '-' + day;
            }
        },

        /**
         * 将毫秒数格式化为yyyy-MM-dd HH:mm:ss
         * @returns
         */
         formatMillisecondToDate(tObj){
                if(tObj==null||tObj==""){
                    return "";
                }else{
                    var tim =  new Date(tObj);
                    var year = tim.getFullYear(); //年
                    var month = tim.getMonth() + 1; //月
                    month = month < 10 ? '0' + month : month;
                    var day = tim.getDate();//日
                    day = day < 10 ? '0' + day : day;
                    var hour = tim.getHours();
                    var minute = tim.getMinutes();
                    var second = tim.getSeconds();
                    hour = hour <10 ? '0' + hour : hour;
                    minute = minute <10 ? '0' + minute : minute;
                    second = second <10 ? '0' + second : second;
                    return year + '-' + month + '-' + day+" "+hour+":"+minute+":"+second;
                }
         }

    },
    //判断字符串是否为空
    isBlackStr(str){
        if(!str||$.trim(str)=="")
            return true;
        return false;
    },
    //是否手机号的正则校验
    isPhoneNumber(str){
         //if(/^((13[0-9])|(14[5|7|9])|(15([0-3]|[5-9]))|(18[0-9])|(17[0-9]))\d{8}$/.test(str))
         if ((/^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/.test(str))){
            return true ;
         }
         return false;
    },
    //是否是正整数
    isPositiveInteger(str){
        if( /^[0-9]+$/.test(str))
            return true;
        return false;
    },
    //大于零的浮点数校验 小数点两位最多两位小数,并且整数位不能超过8位
    isfloatingPoint(str){
        if(/^\d{1,8}(\.\d{1,2})?$/.test(str))
            return true;
        return false;
    },
    //是否是身份证号码
    isIdCard(str){
        if(str){
           if(str.length===15){
               if(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/.test(str)){
                     return true;
               }
           }else if(str.length===18){
               if(/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Za-z])$/.test(str)){
                    return true;
               }
           }
        }
        return false;
    },
    //是否是邮箱
    isEmail(str){
        if(/^([a-z0-9A-Z]+[-|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/.test(str))
            return true;
        return false;
    },
    //密码格必须包含字母与数字
    isPassword(str){
         if(/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,20}$/.test(str))
             return true;
         return false;
    },
    //过滤富文本编辑器的html标签
    filterHtmlTag(str){
        if(str){
            str = str.replace(/(\n)/g, "");
            str = str.replace(/(\t)/g, "");
            str = str.replace(/(\r)/g, "");
            str = str.replace(/<\/?[^>]*>/g, "");
            str = str.replace(/\s*/g, "");
            str = str.replace(/&nbsp;/g, '');
            return str;
        }
        return '';
    },
    /** 获取uuid */
    UUID(){
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
    },
    /**
     * 将带有parentId字段的json，转换成带有children格式
     * @param list  要转化的json
     * @param idstr id字段名
     * @param pidstr 父级字段名
    */
    parentToChild(list, idstr, pidstr){
        var result = []
        var temp = {}
        for (var i = 0; i < list.length; i++) {
            temp[list[i][idstr]] = list[i] // 将nodes数组转成对象类型
        }
        for (var j = 0; j < list.length; j++) {
            var tempVp = temp[list[j][pidstr]] // 获取每一个子对象的父对象
            if (tempVp) { // 判断父对象是否存在，如果不存在直接将对象放到第一层
            if (!tempVp['children']) tempVp['children'] = [] // 如果父元素的nodes对象不存在，则创建数组
            tempVp['children'].push(list[j]) // 将本对象压入父对象的nodes数组
            } else {
            result.push(list[j]) // 将不存在父对象的对象直接放入一级目录
            }
        }
        return result
    },
    /*
       * @param: fileName - 文件名称
       * @param: 数据返回 1) 无后缀匹配 - false
       * @param: 数据返回 2) 匹配图片 - image
       * @param: 数据返回 3) 匹配 txt - txt
       * @param: 数据返回 4) 匹配 excel - excel
       * @param: 数据返回 5) 匹配 word - word
       * @param: 数据返回 6) 匹配 pdf - pdf
       * @param: 数据返回 7) 匹配 ppt - ppt
       * @param: 数据返回 8) 匹配 视频 - video
       * @param: 数据返回 9) 匹配 音频 - radio
       * @param: 数据返回 10) 其他匹配项 - other
       * @param: 数据返回 11) 安装包匹配项 - app
       */
    matchType(fileName) {
        // 后缀获取
        var suffix = '';
        // 获取类型结果
        var result = '';
        try {
            var flieArr = fileName.split('.');
            suffix = flieArr[flieArr.length - 1];
        } catch (err) {
            suffix = '';
        }
        // fileName无后缀返回 false
        if (!suffix) {
            result = false;
            return result;
        }
        // 图片格式
        var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
        // 进行图片匹配
        result = imglist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'image';
            return result;
        };
        // 匹配txt
        var txtlist = ['txt'];
        result = txtlist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'txt';
            return result;
        };

        // 匹配zip
        var ziplist = ['zip'];
        result = ziplist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'zip';
            return result;
        };
        // 匹配 excel
        var excelist = ['xls', 'xlsx'];
        result = excelist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'excel';
            return result;
        };
        // 匹配 word
        var wordlist = ['doc', 'docx'];
        result = wordlist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'word';
            return result;
        };
        // 匹配 pdf
        var pdflist = ['pdf'];
        result = pdflist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'pdf';
            return result;
        };
        // 匹配 ppt
        var pptlist = ['ppt'];
        result = pptlist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'ppt';
            return result;
        };
        // 匹配 视频
        var videolist = ['mp4', 'm2v', 'mkv'];
        result = videolist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'video';
            return result;
        };
        // 匹配 音频
        var radiolist = ['mp3', 'wav', 'wmv'];
        result = radiolist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'radio';
            return result;
        }
        // 匹配 音频
        var applist = ['apk', 'ipa'];
        result = applist.some(function (item) {
            return item == suffix;
        });
        if (result) {
            result = 'app';
            return result;
        }
        // 其他 文件类型
        result = 'other';
        return result;
    },
    /**文件上传前限制
     * file:文件 megabyte：多少兆
     * */
    beforeUpload(file,megabyte) {
        var type = this.matchType(file.name);
        if (type!="image" &&type!="zip"&&type!="excel"&&type!="word") {
            return '上传文件只能为 *.jpg *.jpeg  *.bmp  *.gif   *.png  *.doc  *.docx   *.xls *.xlsx  *.zip格式!';
        }
        const isLt2M = file.size / 1024 / 1024 < megabyte;
        if (!isLt2M) {
            return '上传文件大小为'+megabyte+'M以内!';
        }
        return "";
    },
    /**
     * 表格文件流下载
     */
    exportExcel(Url, FileName){
        const getdownAjax = function(url, config){
            return axios.get(url,config)
        }
        getdownAjax(Url, {
          responseType: "blob"
        }).then(res => {
          // console.log("res", res);
          if (res) {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            // console.log(objectUrl);
            // const fileName = FileName;
            const elink = document.createElement("a");
            elink.download = FileName; //下载文件名称,
            elink.style.display = "none";
            elink.href = objectUrl;
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          }
        });
    },
    /**
     * zip文件流下载
     */
    exportZip(Url, FileName){
        axios.get(Url,{
            responseType: 'arraybuffer'
        }).then((res) => {
            const content = res.data
            const blob = new Blob([content], {type: "application/zip"})
            const fileName = FileName;
        if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = window.URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            window.URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
        } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
        }
        }).catch((err) => {
            console.log(err);
        })

    }
};



// WEBPACK FOOTER //
// ./src/utils/util.js